import React from 'react';
import { Box, Typography, useMediaQuery, Button } from '@mui/material';
import { styled } from '@mui/system';
import { useTheme } from '@mui/material/styles';
import CallIcon from '@mui/icons-material/Call';
import WhatsappIcon from '../whatsAppIcon';


const CarCard = ({ car }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const CardContainer = styled(Box)({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    height: isSmallScreen ? '250px' : '500px', // Increased height
    color: '#fff',
    backgroundImage: `linear-gradient(to right, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0)), url(${process.env.PUBLIC_URL}/${car.imageUrl})`,
    backgroundSize: 'contain',
    backgroundRepeat:'no-repeat',
    backgroundPosition: 'right',
    borderRadius: '8px',
    overflow: 'hidden',
    paddingLeft: '20px', // Padding for text alignment
  });

  const DetailsContainer = styled(Box)({
    // zIndex: 1,
    padding: '20px',
    color: '#fff',
    textAlign: 'left',
    textShadow: '1px 1px 4px rgba(0, 0, 0, 0.8)', // Adds a shadow to the text for better visibility
  });

  return (
    <CardContainer>
      <DetailsContainer>
        <Typography
          variant={isSmallScreen ? 'h6' : 'h3'} // Larger font for the car name
          component="div"
          fontWeight="bold"
        >
          {car.name}
        </Typography>
        <Box display="flex" alignItems="center" mt={1}>
          <Typography variant={isSmallScreen ? 'caption' : 'body1'} component="span" mr={1}>
          🚖 Body Type:
          </Typography>
          <Typography variant={isSmallScreen ? 'caption' : 'body1'} component="span">
            {car.bodyType}
          </Typography>
        </Box>
        <Box display="flex" alignItems="center" mt={1}>
          <Typography variant={isSmallScreen ? 'caption' : 'body1'} component="span" mr={1}>
          💺 Seating Capacity:
          </Typography>
          <Typography variant={isSmallScreen ? 'caption' : 'body1'} component="span">
            {car.seatingCapacity} Seats
          </Typography>
        </Box>
        <Typography
          variant={isSmallScreen ? 'body1' : 'h5'}
          component="div"
          mt={2}
        >
          {`₹${car.price} per day`}
        </Typography>
        <Typography variant="body1" component="div">
          {car.type}
        </Typography>
        <Button
          variant="contained"
          startIcon={<CallIcon />}
          sx={{
            backgroundColor: '#5585b5',
            '&:hover': {
            backgroundColor: '#3b5e7f', // Hover background color
          },
          }}
          onClick={() => window.open('tel:7015006321', '_self')}
        >
          Call to Rent
        </Button>
        <WhatsappIcon name={car.name}/>
      </DetailsContainer>
    </CardContainer>
  );
};

export default CarCard;
